import * as angular from 'angular';
import {IController, IWindowService} from "angular";
import {BringozToastService} from "../../services/bringoz-toast.service";

export class UrlTextCopyComponent implements IController {

  constructor(private $window: IWindowService, private bringozToastService: BringozToastService) {
  }

  copyToClipboard() {
    const url = this.$window.location.href;
    this.$window.navigator.clipboard.writeText(url).then((res) => {
      const message = {
        body: 'TEXT_COPIED_TO_CLIPBOARD'
      };
      this.bringozToastService.success(message);
    });
  }


}

angular
  .module('bringoz.admin.commons')
  .component('urlTextCopy', {
    bindings: {},
    template: require('./url-text-copy.html').default,
    controller: UrlTextCopyComponent
  });


